module.exports = __webpack_public_path__ + "static/media/archive-successful.4c3d6175.svg";